import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../../Services/Api/ApiServices";

export const GetAllSupportType = createAsyncThunk(
  "DropDowns/GetAllSupportType",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/DropDowns/GetAllSupportType");

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const DropDownSupportType = createSlice({
  name: "DropDownSupportType",
  initialState: {
    DropDownSupportType: [],
    loadingDropDownSupportType: false,
    errorDropDownSupportType: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllSupportType.pending, (state, action) => {
        state.loadingDropDownSupportType = true;
        state.DropDownSupportType = action.payload;
        state.errorDropDownSupportType = null;
      })
      .addCase(GetAllSupportType.fulfilled, (state, action) => {
        state.loadingDropDownSupportType = false;
        state.DropDownSupportType = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllSupportType.rejected, (state, action) => {
        state.loadingDropDownSupportType = false;
        state.errorDropDownSupportType = action.payload;
      });
  },
});

export default DropDownSupportType.reducer;
